export default __webpack_public_path__ + "static/media/5.b5d6d324.jpg";